import React from 'react';
import clsx from 'clsx';

import './TrialTimeline.scss';

export interface TrialStep {
  icon: React.ComponentType<{
    width?: number | string;
    height?: number | string;
    style?: React.CSSProperties;
    fill?: string;
  }>;
  title: string;
  description?: string;
}

interface TrialTimelineProps {
  steps: TrialStep[];
  hideStep3?: boolean;
  className?: string;
}

export const TrialTimeline: React.FC<TrialTimelineProps> = ({
  steps,
  hideStep3 = false,
  className,
}) => {
  const step1 = steps[0];
  const step2 = steps[1];
  const remainingSteps = steps.slice(2);
  const Step1Icon = step1?.icon;
  const Step2Icon = step2?.icon;

  return (
    <div className={clsx('trial-timeline', className)}>
      <div className="trial-timeline__left-rail">
        {/* Wrapper for Step 1 and Step 2 with purple background */}
        {step1 && step2 && Step1Icon && Step2Icon && (
          <div className="trial-timeline__steps12-wrapper">
            {/* Step 1 */}
            <div
              className={clsx(
                'trial-timeline__step-container',
                'trial-timeline__step-container--step1'
              )}
              style={{ minHeight: step1.description ? 72 : 32 }}
            >
              <Step1Icon
                width={20}
                height={20}
                style={{ color: 'var(--color-white-lightest)' }}
                fill="var(--color-white-lightest)"
              />
            </div>
            {/* Step 2 */}
            <div
              className={clsx(
                'trial-timeline__step-container',
                'trial-timeline__step-container--step2'
              )}
            >
              <Step2Icon
                width={20}
                height={20}
                style={{ color: 'var(--color-white-lightest)' }}
                fill="var(--color-white-lightest)"
              />
            </div>
          </div>
        )}

        {/* Remaining steps (Step 3, etc.) */}
        {!hideStep3 &&
          remainingSteps.map(({ icon: IconComponent, description }, index) => {
            const minHeight = (description ? 72 : 32) + 10; // 10 is the height of the step 2 icon
            const actualIndex = index + 2; // Adjust index for remaining steps

            return (
              <div
                key={actualIndex}
                className={clsx(
                  'trial-timeline__step-container',
                  'trial-timeline__step-container--white'
                )}
                style={{ minHeight }}
              >
                <IconComponent
                  width={20}
                  height={20}
                  style={{ color: 'var(--color-primary)' }}
                  fill="var(--color-primary)"
                />
              </div>
            );
          })}
      </div>
      <div className="trial-timeline__right-content">
        {steps
          .filter((_, index) => (hideStep3 ? index < 2 : true))
          .map(({ title, description }, index) => (
            <div
              key={index}
              className="trial-timeline__content-item"
              style={{ minHeight: description ? 72 : 32 }}
            >
              <div className="trial-timeline__title">{title}</div>
              {!!description && <div className="trial-timeline__description">{description}</div>}
            </div>
          ))}
      </div>
    </div>
  );
};
